/**
 * Image Carousel controller.
 */

import '@accessible360/accessible-slick';

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Export the class reference.
 */
export default class ImageCarousel {

    /**
     * Cache dom elements for use in the class's methods
     *
     * @return {void}
     */
    cache() {
        this.carousels = document.querySelectorAll( '.image-carousel__slides' );
    }

    /**
     * Initialize image carousel(s).
     *
     * @return {void}
     */
    initCarousels() {
        const translations = themeData.themeStrings.imagecarousel; // eslint-disable-line

        const icons = {
            prev: '<span class="icon-arrow icon-arrow--left"></span>',
            next: '<span class="icon-arrow icon-arrow--right"></span>'
        };

        const prevSrText = `<span class="u-sr-only">${ translations.imagecarousel_prev }</span>`;
        const nextSrText = `<span class="u-sr-only">${ translations.imagecarousel_next }</span>`;

        const arrowClass = '';

        const buttons = {
            prevArrow: this.makeButton( icons.prev + prevSrText, `${ arrowClass } slick-prev` ),
            nextArrow: this.makeButton( icons.next + nextSrText, `${ arrowClass } slick-next` )
        };

        this.carousels.forEach( ( carousel ) => {
            this.constructCarousel( carousel, buttons );
        });
    }

    /**
     * Constructs the carousel(s).
     *
     * @param {HTMLElement} carousel Main carousel element.
     * @param {Object} buttons Buttons to use.
     *
     * @return {*|jQuery|HTMLElement} Constructed main carousel.
     */
    constructCarousel( carousel = undefined, buttons = {}) {
        const translations = themeData.themeStrings.imagecarousel; // eslint-disable-line

        const carouselOptions = {
            regionLabel: translations.imagecarousel_label,
            slidesToShow: 1,
            draggable: false,
            prevArrow: buttons.prevArrow,
            nextArrow: buttons.nextArrow,
            arrowsPlacement: 'split',
            dots: true,
            appendDots: '.image-carousel__dots',
            customPaging: ( slider, i ) => {
                const dotIcon = '<span class="slick-dot-icon" aria-hidden="true"></span>';
                const srLabel = `<span class="u-sr-only">${ translations.imagecarousel_goto } ${ i + 1 }</span>`;
                return this.makeButton( dotIcon + srLabel );
            }
        };

        // Initialize Slick
        $( carousel ).slick( carouselOptions );

        return carousel;
    }

    /**
     * Makes a button element
     *
     * @param {string} contents What to add inside the button element.
     * @param {string} classes CSS Classes to add to the element.
     * @param {string} type Type of the button, 'button' as default.
     *
     * @return {string} Button element HTML.
     */
    makeButton( contents = '', classes = '', type = 'button' ) {
        const button = document.createElement( 'button' );

        if ( classes.length ) {
            button.className = classes;
        }

        if ( type.length ) {
            button.type = type;
        }

        if ( contents.length ) {
            button.insertAdjacentHTML( 'afterbegin', contents );
        }

        return button.outerHTML;
    }

    /**
     * Run when the document is ready.
     *
     * @return {void}
     */
    docReady() {
        this.cache();

        if ( this.carousels.length ) {
            this.initCarousels();
        }
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/image-carousel.js